module.exports = __webpack_public_path__ + "public/img/chuangru.88b03d7d.jpg";